import { render, staticRenderFns } from "./UserReportList.vue?vue&type=template&id=0ae1a6e0&"
import script from "./UserReportList.vue?vue&type=script&lang=js&"
export * from "./UserReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports